/* eslint-disable max-lines */
import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import moment from 'moment';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {LoaderDetailList} from '../internalCommons/loaderDetailList';

const tableHeaderWithProps = () => {
  return [
    {
      'Header': () => <span className="header-title-summary">PEDIDO</span>,
      'accessor': 'orderNumber',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title-summary">UNIDADES</span>,
      'accessor': 'amount',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title-summary">EMBARQUE</span>,
      'accessor': 'shipment',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title-summary">FACTURA</span>,
      'accessor': 'invoiceNumber',
      'width': 150,
    },
    {
      'Header': () => <span className="header-title-summary">UNIDADES</span>,
      'accessor': 'amountShipment',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <div
            className={row.original.shipment === 'Pendiente' &&
              parseInt(row.original.amountShipment, 10) !== 0 ?
              'pending-alert' :
              'pending-normal'
            }>
            {row.original.amountShipment}
          </div>
        );
      },
    },
    {
      'Header': () => <span className="header-title-summary">LIQUIDADAS</span>,
      'accessor': 'saleCount',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <div
            className={'pending-liq'}>
            {row.original.saleCount}
          </div>
        );
      },
    },
    {
      'Header': () => <span className="header-title-summary">ETA</span>,
      'accessor': 'arrivalDate',
      'width': 150,
      'Cell': ({row}) => {
        return (
          <span>{moment(row.original.arrivalDate).format(reverseShortDate)}</span>
        );
      },
    },
  ];
};

const SumaryTable = ({orderSummary, loading}) => {
  const clone = cloneDeep(orderSummary);
  const columnsTable = tableHeaderWithProps();
  const data = useMemo(() => clone, [orderSummary]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
  } = useTable(
    {
      columns,
      data,
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div>
        <Table className="interactive" compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup, index) => (
              <Table.Row key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell key={`filter-${index}`} textAlign="center">
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {loading ? (
              <LoaderDetailList />
            ) :
              (
                <>
                  {page.length > 0 &&
                  page.map((row, i) => {
                    prepareRow(row);
                    return (
                      <Table.Row key={i} className="row-custom">
                        {row.cells.map((cell) => {
                          return (
                            <Table.Cell
                              textAlign="center"
                              className={cell.column.className}
                            >
                              {cell.render('Cell')}
                            </Table.Cell>
                          );
                        })}
                      </Table.Row>
                    );
                  })}
                </>
              )}
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  'loading': state.manageOrders.loading,
  'listDealers': state.dealer.list,
  'orderSummary': state.manageOrders.orderSummary,
});

const {fetchOrigins} = Actions;

export default connect(mapStateToProps, {
  fetchOrigins,
})(SumaryTable);
